import { NumericFormat } from "react-number-format";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export function Field({ label, hint, tip, children, className = "", htmlFor }) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      {label && (
        <div className="flex items-center gap-1.5">
          <Label htmlFor={htmlFor} className="text-xs font-medium text-[hsl(45_15%_80%)]">
            {label}
          </Label>
          {tip && (
            <Tooltip>
              <TooltipTrigger asChild>
                <Info className="h-3.5 w-3.5 text-muted-foreground hover:text-primary cursor-help" />
              </TooltipTrigger>
              <TooltipContent className="max-w-xs text-xs bg-popover border border-border text-foreground">{tip}</TooltipContent>
            </Tooltip>
          )}
        </div>
      )}
      {children}
      {hint && <p className="text-[11px] text-muted-foreground leading-snug">{hint}</p>}
    </div>
  );
}

const inputCls =
  "h-10 bg-[hsl(220_12%_8%)] border-[hsl(220_10%_18%)] text-sm num focus-visible:ring-1 focus-visible:ring-primary focus-visible:border-primary/60 disabled:opacity-70";

export function MoneyInput({ value, onChange, testid, disabled, placeholder = "0", className = "", allowNegative = false }) {
  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground pointer-events-none">Rp</span>
      <NumericFormat
        value={value === 0 || value ? value : ""}
        onValueChange={(v) => onChange(v.floatValue ?? 0)}
        thousandSeparator="."
        decimalSeparator=","
        decimalScale={0}
        allowNegative={allowNegative}
        customInput={Input}
        placeholder={placeholder}
        disabled={disabled}
        inputMode="numeric"
        className={`${inputCls} pl-9 text-right ${className}`}
        data-testid={testid}
      />
    </div>
  );
}

export function NumInput({ value, onChange, testid, disabled, suffix, decimals = 2, min, className = "", placeholder = "0" }) {
  return (
    <div className="relative">
      <NumericFormat
        value={value === 0 || value ? value : ""}
        onValueChange={(v) => {
          let x = v.floatValue ?? 0;
          if (min !== undefined && x < min) x = min;
          onChange(x);
        }}
        thousandSeparator="."
        decimalSeparator=","
        decimalScale={decimals}
        allowNegative={false}
        customInput={Input}
        placeholder={placeholder}
        disabled={disabled}
        inputMode="decimal"
        className={`${inputCls} text-right ${suffix ? "pr-12" : ""} ${className}`}
        data-testid={testid}
      />
      {suffix && (
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground pointer-events-none">{suffix}</span>
      )}
    </div>
  );
}

export function TextInput({ value, onChange, testid, disabled, placeholder, className = "" }) {
  return (
    <Input
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      className={`h-10 bg-[hsl(220_12%_8%)] border-[hsl(220_10%_18%)] text-sm focus-visible:ring-1 focus-visible:ring-primary ${className}`}
      data-testid={testid}
    />
  );
}
